module.exports = __webpack_public_path__ + "images/assets/cc902a0b824ea0b6662c83ba9368edd4.svg";